module.exports = require('./$.hide');


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/~/core-js/library/modules/$.redefine.js
 ** module id = 248
 ** module chunks = 0
 **/